// @flow

import React from 'react';
import Carousel from 'app/components/commons/Carousel';
import PlaceSingle from './PlaceSingle';

type Props = {
  displayCountry: boolean,
  entries: Array<Object>,
  position: number,
};

function Place({
  displayCountry,
  entries,
  position,
}: Props) {
  return (
    <div>
      <Carousel
        slidesToScroll={1}
        slidesToShow={1}
        smallButtons
      >
        {entries.map(entry => (
          <PlaceSingle
            avatar={entry.userAvatar}
            countryFlag={displayCountry ? entry.countryFlag : undefined}
            key={entry.userId}
            name={entry.userName}
            score={entry.globalScore}
            winner={position === 1}
          />
        ))}
      </Carousel>
    </div>
  );
}

export default Place;
